<template>
    <div class="mintSection">
        <br><br>
        <b-container class="contained">
            <b-row>
                <b-col cols="12">
                    <h2 class="white topMargin">VANILLA HOLDING</h2>
                    <br>
                    <h4 class="white">MINT A VANILLA HOLDING NFT</h4>
                    <br>
                    <img class="nftImg" src="../assets/nftLoop.gif" alt="">
                    <br><br>
                    <h4 class="white">{{totalMinted}} / 5000</h4>
                    <br>
                    <h4 class="white">PRICE : {{priceToDisplay}} ETH <span style="font-size:1.4vh;">(Will Change to be 2000$ USD)</span></h4>
                    <br>
                    <input type="number" min="1" class="mintAmount" v-model="amountToMint">
                    <button class="button-11" role="button" @click="mint()">MINT</button>
                </b-col>
            </b-row>
        </b-container>
        <br><br><br><br><br><br><br><br>
        <br><br><br><br>
    </div>
</template>

<script>
import Web3 from 'web3';
import vContract from '../assets/contract.json'

    export default {
        data: function () {
            return {
                web3: '',
                walletAddress: '',
                walletBalance: '',

                vanillaContract: '',
                contractAddress: vContract.contractAddress,
                contractABI: vContract.abi,

                totalMinted: 0,
                priceToMint: 0,
                priceToDisplay: 0,
                amountToMint: 1,

                loadingTransaction: false,
            }
        },
        mounted()
        {
            this.LoadEthWallet();
            this.LoadContract();  
        },
        methods:{
            mint()
            {
                this.loadingTransaction = true
                this.vanillaContract.methods.buyVanilla(this.amountToMint).send({from: this.walletAddress, value: (this.priceToMint * this.amountToMint)})
                .on('confirmation', function(confirmationNumber, receipt)
                {
                    
                })
                .then(res=>{
                    this.LoadContract();
                    this.loadingTransaction = false;
                })
                .catch(err=>{
                    this.LoadContract();
                    this.loadingTransaction = false;
                })
            },
            async chainChange()
            {
                await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: '0x1' }], // chainId must be in hexadecimal numbers
                    });
                this.LoadEthWallet();
            },
            LoadEthWallet: function(){
                if (typeof window.ethereum !== 'undefined') 
                {
                    this.web3 = new Web3(window.ethereum || new Web3.providers.HttpProvider("https://mainnet.infura.io/v3/5953fa0192404ecca6c68f5c0ca2dd70") || Web3.givenProvider);
                    this.web3.eth.net.getNetworkType()
                    .then(network=>{
                        if(network == "main")
                        {
                        
                        this.web3.eth.requestAccounts()
                            .then(acc=>{
                            this.walletAddress = acc[0];
                            this.web3.eth.getBalance(this.walletAddress)
                                .then(balance=>{
                                    this.walletBalance = this.web3.utils.fromWei(balance, "ether");
                                       
                                });
                            })
                            .catch(err=>{
                                console.log(err);
                            })            
                        }
                        else{
                            this.chainChange();
                        }          
                    })
                }
            },
            LoadContract: function()
            {
                this.web3 = new Web3(window.ethereum || new Web3.providers.HttpProvider("https://mainnet.infura.io/v3/5953fa0192404ecca6c68f5c0ca2dd70") || Web3.givenProvider);
                this.vanillaContract = new this.web3.eth.Contract(this.contractABI, this.contractAddress);

                this.vanillaContract.methods.totalSupply().call({})
                .then(res=>{
                    this.totalMinted = res;
                })

                this.vanillaContract.methods.vanillaPrice().call({})
                .then(res=>{
                    this.priceToMint = res;

                    this.priceToDisplay = this.web3.utils.fromWei(res, 'ether')
                })
            }
        }

    }
</script>

<style scoped>
.mintSection
{
    background: #256ea4;
}
.contained
{

}
.nftImg
{
    height: 300px;
    border-radius: 100px/100px;
    border: white 2px solid;
}
.white
{
    color: white;
}
.topMargin
{
    margin-top: 10vh;
}

.mintAmount
{
    width: 100px;
    text-align: center;
    border-radius: 999px;
}
/* CSS */
.button-11 {
    margin-top: 2vh;
  padding: 6px 14px;
  border-radius: 6px;
  color: #3D3D3D;
  background: #fff;
  border: none;
  box-shadow: 0px 0.5px 1px rgba(0, 0, 0, 0.1);
}

.button-11:focus {
  box-shadow: 0px 0.5px 1px rgba(0, 0, 0, 0.1), 0px 0px 0px 3.5px rgba(58, 108, 217, 0.5);
  outline: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Mint.vue